import { careerStateSelector } from '@careerhub/common';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';
import * as React from 'react';
import { useSelector } from 'react-redux';

/** Renders the current error message in a dismissable message bar. Currently only for bookmarks. */
export const ErrorMessage = () => {
  const { errorMessage } = useSelector(careerStateSelector);
  const [dismissed, setDismissed] = React.useState(false);

  React.useEffect(() => {
    setDismissed(false);
  }, [errorMessage]);

  return errorMessage && !dismissed ? (
    <MessageBar messageBarType={MessageBarType.error} onDismiss={() => setDismissed(true)}>
      {errorMessage}
    </MessageBar>
  ) : null;
};
